import axiosInstance from "./axiosInstance";

// Тип ответа от API
interface UserApiResponse {
  id: number;
  username: string;
  email?: string;
  full_name?: string;
  role?: 'user' | 'admin' | 'superadmin';
  language?: string;
}

// ОБНОВИТЕ функцию getCurrentUser
export const getCurrentUser = async (): Promise<UserApiResponse> => {
  const { data } = await axiosInstance.get<UserApiResponse>("/me");
  return data;
};

export const updateProfile = async (data: { language?: string }) => {
  const response = await axiosInstance.put<UserApiResponse>("/me", data);
  return response.data;
};

interface LoginResponse {
  access_token: string;
  token_type: string;
  admin_token?: string;
}

export const loginRequest = async (username: string, password: string) => {
  const response = await axiosInstance.post<LoginResponse>("/login", {
    username,
    password,
  });
  
  // Store admin token if present
  if (response.data.admin_token) {
    localStorage.setItem('adminToken', response.data.admin_token);
  }
  
  return response.data.access_token;
};

export const logoutRequest = async () => {
  await axiosInstance.post("/logout");
  // Clear all tokens
  localStorage.removeItem('access_token');
  localStorage.removeItem('adminToken');
};